/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Copy16 from '@carbon/icons-react/es/copy/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Menu } from 'components/atoms/dropdown/menu';
import { MoreActionsDropdown } from 'components/atoms/more-actions';
import { TemplateId, TemplateObjectType } from 'data/templates/api';
import { useDeleteConfirmModal } from 'hooks/use-delete-confirm-modal';
import { useTranslation } from 'hooks/use-translation';
import { TemplateListProp } from './types';

const menu = ({
  templateId,
  objectType,
  onDelete,
  onDuplicate,
}: {
  templateId: TemplateId;
  objectType: TemplateObjectType;
  onDelete: () => void;
  onDuplicate?: (id, objectType: TemplateObjectType) => void;
}) => (
  <Menu data-cy="menu" data-template-id={templateId}>
    {onDuplicate ? (
      <Menu.Item
        data-cy="menu-items.duplicate"
        onClick={() => onDuplicate(templateId, objectType)}
        key="duplicate"
        icon={<Copy16 className="anticon anticon-user" />}
      >
        <FormattedMessage id="templates.more_actions.duplicate" />
      </Menu.Item>
    ) : (
      ''
    )}
    <Menu.ItemDelete
      data-cy="menu-items.delete"
      key="delete"
      onClick={onDelete}
    />
  </Menu>
);

export const TemplateCardMoreActions: FC<{
  className?: string;
  template: TemplateListProp;
  objectType: TemplateObjectType;
  onDelete: (id, objectType: TemplateObjectType) => void;
  onDuplicate?: (id, objectType: TemplateObjectType) => void;
}> = ({ className, template, onDelete, objectType, onDuplicate }) => {
  const deleteTitle = useTranslation('template.delete.confirm.title');
  const deleteConfirmationText = useTranslation(
    'template.delete.confirm.message',
  );
  const DeleteConfirmation = useDeleteConfirmModal({
    title: deleteTitle,
    content: deleteConfirmationText,
    onOk: () => onDelete(template.templateId, objectType),
  });

  // Stop propogating the event so that card won't navigate to template detail page.
  return (
    <div
      data-cy={`buttons.more-actions.${template.templateId}`}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <MoreActionsDropdown
        className={className}
        menu={menu({
          templateId: template.templateId,
          objectType,
          onDelete: DeleteConfirmation,
          onDuplicate,
        })}
      />
    </div>
  );
};
